import { defineMessages } from 'react-intl.macro';

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useDispatch } from '@tmapy/redux';
import { SecondaryBtn } from '@tmapy/style-guide';

import { twistLogout } from '../actions';

const msg = defineMessages({
  update: {
    id: 'auth.update.button',
    defaultMessage: 'Aktualizovat',
  },
});

export const UpdateUserBtn: React.FC = React.memo(() => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(twistLogout());
  };

  return (
    <SecondaryBtn onClick={handleClick}>
      <FormattedMessage {...msg.update} />
    </SecondaryBtn>
  );
});
